// extracted by mini-css-extract-plugin
module.exports = {"button":"PayForm_button__2kcm6","blue":"PayForm_blue__2vfU7","medium":"PayForm_medium__1LHSI"};